function getInt (min, max) {
  return min + Math.floor(
    Math.random() * (Math.floor(max + 1) - Math.ceil(min))
  )
}

function getIndex (list) {
  return getInt(0, list.length - 1)
}

function getInList (list) {
  const index = getIndex(list)
  return list[index]
}

export default {
  getInt,
  getIndex,
  getInList
}
